module.exports = __webpack_public_path__ + "img/icon_check_mid.162830eb.svg";